export const getWorklogItem = `
id
sk
description
worklogTimeSpent
worklogTimeRemaining
creator {
  firstName
  lastName
  avatarHash
}
`;

export const getWorklogsForResource = `
id
sk
name
worklogs {
  id
  sk
  createdAt
  worklogTimeSpent
  workspaceId
  creator {
    id
    firstName
    lastName
    avatarHash
  }
}
`;
